export default __webpack_public_path__ + "static/media/1128040325511620.3da24fb6.jpg";